import { createPortal } from "react-dom";
import React from "react";
import "./DeleteConfirmModal.scss";
import "./BuilderAlertModal.scss";

export type BuilderAlertModalProps = {
  open: boolean;
  message: string;
  details?: string[];
  onClose: () => void;
  closeLabel?: string;
};

export default function BuilderAlertModal({
  open,
  message,
  details = [],
  onClose,
  closeLabel = "OK",
}: BuilderAlertModalProps) {
  if (!open) {
    return null;
  }

  return createPortal(
    <div
      className="builder-alert-modal-backdrop"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="delete-confirm-modal-container builder-alert-modal-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="builder-alert-modal-title"
      >
        <div className="delete-confirm-heading" id="builder-alert-modal-title">
          {message}
        </div>
        {details.length > 0 && (
          <ul
            style={{
              color: "#fff",
              fontSize: 13,
              margin: "8px 0 0",
              paddingLeft: 18,
            }}
          >
            {details.map((line, i) => (
              <li key={i}>{line}</li>
            ))}
          </ul>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 16,
          }}
        >
          <button
            type="button"
            className="delete-confirm-cancel"
            onClick={onClose}
          >
            {closeLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
